import { client } from "../../client";
import { MeterPointConfig } from "../../meters";

export const getMeterPointConfig = (
  key: string,
  {
    meterPointId,
    date,
  }: {
    meterPointId: number | string;
    date?: string;
  },
) => {
  let url = `meterpoints/${meterPointId}/config`;
  if (date) url += `?date=${date}`;

  return client.get<MeterPointConfig>(url).then((response) => response.data);
};
